<template>
  <div class="mx-auto container container--fluid">
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <!--  IMAGE PREVIEW DIALOG -->
    <v-dialog v-model="previewDialog" max-width="650px" persistent>
      <v-card>
        <v-card-title class="d-flex justify-space-between align-center">
          <span class="font-weight-bold">Image Preview</span>
          <v-btn icon @click="previewDialog = false">
            <v-icon color="red">mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="text-center">
          <v-img
            v-if="previewImageUrl"
            :src="previewImageUrl"
            max-height="450"
            contain
            class="rounded elevation-2"
          />
          <div v-else class="grey--text">No Image Available</div>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-btn color="primary" @click="previewDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-card class="box">
      <v-data-table
        :headers="headers"
        :items="filtered_logo_list"
        class="elevation-1 mytable"
        dense
        :search="search"
        :loading="tableLoader"
      >
        <!--  Sr No -->
        <template v-slot:item.srno="{ item }">
          {{ filtered_logo_list.indexOf(item) + 1 }}
        </template>

        <!--  MAIN LOGO ONLY EYE ICON -->
        <template v-slot:item.logo_path="{ item }">
          <v-icon
            v-if="item.logo_path"
            color="primary"
            small
            style="cursor:pointer"
            title="View Main Logo"
            @click="openPreview(getFullPath(item.logo_path))"
          >
            mdi-eye-outline
          </v-icon>

          <v-icon v-else color="grey" small title="No Main Logo">
            mdi-eye-off-outline
          </v-icon>
        </template>

        <!--  TRUST LOGO ONLY EYE ICON -->
        <template v-slot:item.trust_logo="{ item }">
          <v-icon
            v-if="item.trust_logo"
            color="primary"
            small
            style="cursor:pointer"
            title="View Trust Logo"
            @click="openPreview(getFullPath(item.trust_logo))"
          >
            mdi-eye-outline
          </v-icon>

          <v-icon v-else color="grey" small title="No Trust Logo">
            mdi-eye-off-outline
          </v-icon>
        </template>

        <!--  Toolbar -->
        <template v-slot:top>
          <v-toolbar dense class="toolbar" flat color="white">
            <v-toolbar-title>Login Logo Master</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
          </v-toolbar>

          <!--  Filter -->
          <v-row dense justify="center">
            <v-col cols="auto">
              <v-icon color="error">*</v-icon>
            </v-col>
            <v-col cols="4">
              <v-autocomplete
                label="Select Domain/Logo Name"
                v-model="selected_filter_name"
                :items="logo_list"
                item-text="logo_name"
                outlined
                required
                dense
                class="mt-2"
              />
            </v-col>
            <v-col cols="auto">
              <v-btn
                class="primary button mt-2"
                @click="filteredList"
                :disabled="!selected_filter_name"
              >
                Fetch
              </v-btn>
            </v-col>
          </v-row>

          <span style="width: 20px"></span>

          <!--  Export + Search + Dialog -->
          <v-row dense align="center">
            <v-col cols="12" sm="3" md="3" class="d-flex align-center ml-2 mt-2 mb-2">
              <v-btn rounded color="success" outlined :loading="overlay" @click="downloadFile">
                <v-icon left color="success">mdi-export</v-icon>
                Export
              </v-btn>
            </v-col>

            <v-col class="mr-8" sm="6" md="5" cols="12">
              <v-text-field
                v-model="search"
                append-icon="search"
                label="Search"
                single-line
                hide-details
              />
            </v-col>

            <!--  Add/Edit Dialog -->
            <v-dialog v-model="dialog" max-width="650px">
              <template v-slot:activator="{ on }">
                <v-btn class="mb-2 button" small v-on="on" @click="openAddDialog">
                  Add Login Logo
                </v-btn>
              </template>

              <v-card justify="center">
                <v-form v-model="valid" ref="form">
                  <v-card-title class="toolbar">
                    <span class="headline">{{ formTitle }}</span>
                  </v-card-title>

                  <v-container class="pa-6">
                    <v-row dense>
                      <!--  Logo Name -->
                      <v-col cols="12">
                        <v-icon color="error" small>*</v-icon>
                        <v-text-field
                          label="Logo Name"
                          v-model="editedItem.logo_name"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'Required']"
                        />
                      </v-col>

                      <!--  Domain Name (Readonly in edit mode) -->
                      <v-col cols="12">
                        <v-icon color="error" small>*</v-icon>
                        <v-text-field
                          label="Domain Name"
                          v-model="editedItem.domainname"
                          outlined
                          dense
                          required
                          :rules="[v => !!v || 'Required']"
        
                        />
                      </v-col>

                      <!--  Display Name -->
                      <v-col cols="12">
                        <v-text-field
                          label="Login Display Name"
                          v-model="editedItem.login_displayname"
                          outlined
                          dense
                        />
                      </v-col>

                      <!--  Current Main Logo (Eye + Remove) -->
                      <v-col cols="12" v-if="editedIndex !== -1">
                        <div class="d-flex align-center justify-space-between">
                          <div class="text-caption grey--text">
                            Main Logo :
                            <b>{{ editedItem.logo_path ? getFileName(editedItem.logo_path) : "Not Available" }}</b>
                          </div>

                          <div class="d-flex align-center">
                            <v-icon
                              v-if="editedItem.logo_path"
                              color="primary"
                              small
                              style="cursor:pointer"
                              title="View Main Logo"
                              @click="openPreview(getFullPath(editedItem.logo_path))"
                            >
                              mdi-eye-outline
                            </v-icon>

                            <!-- <v-btn
                              v-if="editedItem.logo_path"
                              small
                              color="red"
                              outlined
                              class="ml-3"
                              @click="removeMainLogo"
                            > 
                              <v-icon left small>mdi-delete</v-icon>
                              Remove
                            </v-btn>-->
                          </div>
                        </div>
                      </v-col>

                      <!--  Upload Main Logo -->
                      <v-col cols="12">
                        <v-icon color="error" small>*</v-icon>
                        <v-file-input
                          label="Main Logo (Upload Image)"
                          v-model="logoFile"
                          accept="image/*"
                          outlined
                          dense
                          show-size
                          prepend-icon="mdi-image"
                          :rules="editedIndex === -1 ? [v => !!v || 'Logo required'] : []"
                        />
                        <div v-if="logoFile" class="text-caption mt-1">
                          New Selected File : <b>{{ logoFile.name }}</b>
                        </div>
                      </v-col>

                      <!--  Current Trust Logo (Eye + Remove) -->
                      <v-col cols="12" v-if="editedIndex !== -1">
                        <div class="d-flex align-center justify-space-between">
                          <div class="text-caption grey--text">
                            Trust Logo :
                            <b>{{ editedItem.trust_logo ? getFileName(editedItem.trust_logo) : "Not Available" }}</b>
                          </div>

                          <div class="d-flex align-center">
                            <v-icon
                              v-if="editedItem.trust_logo"
                              color="primary"
                              small
                              style="cursor:pointer"
                              title="View Trust Logo"
                              @click="openPreview(getFullPath(editedItem.trust_logo))"
                            >
                              mdi-eye-outline
                            </v-icon>

                            <v-icon left small
                              v-if="editedItem.trust_logo"
                              
                              color="red"
                              small,
                              outlined
                              style="cursor:pointer"
                              class="ml-3"
                              @click="removeTrustLogo"
                            
                              >mdi-delete-outline</v-icon>
                              <!-- Remove -->
                           
                          </div>
                        </div>
                      </v-col>

                      <!--  Upload Trust Logo -->
                      <v-col cols="12">
                        <v-file-input
                          label="Trust Logo (Optional)"
                          v-model="trustLogoFile"
                          accept="image/*"
                          outlined
                          dense
                          show-size
                          prepend-icon="mdi-image-outline"
                        />
                        <div v-if="trustLogoFile" class="text-caption mt-1">
                          New Selected File : <b>{{ trustLogoFile.name }}</b>
                        </div>
                      </v-col>
                    </v-row>
                  </v-container>

                  <v-card-actions class="justify-center pt-0 pb-4">
                    <v-btn class="button" @click="close()">Cancel</v-btn>
                    <v-btn color="primary button" @click="save" :disabled="!valid">
                      {{ editedIndex === -1 ? "Save" : "Update" }}
                    </v-btn>
                  </v-card-actions>
                </v-form>
              </v-card>
            </v-dialog>
          </v-row>
        </template>

        <!--  Actions -->
        <template v-slot:item.action="{ item }">
          <div class="d-flex align-center">
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="edit-v-icon" small @click="editItem(item)">edit</v-icon>
            </v-avatar>

            <v-avatar size="25" class="delete-avatar ml-2">
              <v-icon class="delete-v-icon" small @click="deleteItem(item)">mdi-delete</v-icon>
            </v-avatar>
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
  name: "LoginLogoMaster",
  data: () => ({
    basepath: "",
    valid: false,
    overlay: false,
    tableLoader: false,
    snackbar: false,
    snackbar_msg: "",
    color: "",
    search: "",
    selected_filter_name: "",
    logo_list: [],
    filtered_logo_list: [],
    dialog: false,

    //  Preview dialog
    previewDialog: false,
    previewImageUrl: "",

    //  remove flags
   // removeMainLogoFlag: false,
    removeTrustLogoFlag: false,

    headers: [
      { text: "S.No", value: "srno", align: "left", sortable: false },
      { text: "Main Logo", value: "logo_path", sortable: false },
      { text: "Trust Logo", value: "trust_logo", sortable: false },
      { text: "Logo Name", value: "logo_name", align: "left" },
      { text: "Domain Name", value: "domainname", align: "left" },
      { text: "Display Name", value: "login_displayname", align: "left" },
      { text: "Actions", value: "action", sortable: false, align: "center" },
    ],

    logoFile: null,
    trustLogoFile: null,

    editedIndex: -1,
    editedItem: {
      id: "",
      logo_name: "",
      domainname: "",
      login_displayname: "",
      logo_path: "",
      trust_logo: "",
    },

    defaultItem: {
      id: "",
      logo_name: "",
      domainname: "",
      login_displayname: "",
      logo_path: "",
      trust_logo: "",
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "Add Login Logo" : "Edit Login Logo";
    },
  },

  mounted() {
    this.basepath = localStorage.getItem("awspath") || "http://localhost:8080";
    this.getLogoList();
  },

  methods: {
  //  Convert local path to full URL
  getFullPath(path) {
    if (!path) return "";
    if (path.startsWith("http")) return path;
    return this.basepath + path;
  },

  openAddDialog() {
    this.editedIndex = -1;
    this.editedItem = Object.assign({}, this.defaultItem);
    this.logoFile = null;
    this.trustLogoFile = null;
    this.dialog = true;
  },

  openPreview(url) {
    if (!url) return;
    this.previewImageUrl = url;
    this.previewDialog = true;
  },

  getFileName(url) {
    if (!url) return "";
    return url.split("/").pop();
  },

  //  FETCH LIST
  getLogoList() {
    this.tableLoader = true;
    axios
      .post("/AdmissionMaster/getLoginLogoList")
      .then((res) => {
        if (res.data.code === "SUCCESS") {
          this.logo_list = res.data.login_logo_list || [];
          this.filtered_logo_list = this.logo_list;
        } else {
          this.logo_list = [];
          this.filtered_logo_list = [];
        }
      })
      .catch(() => this.showSnackbar("#ff5252", "Error while fetching data"))
      .finally(() => (this.tableLoader = false));
  },

  filteredList() {
    if (!this.selected_filter_name) return;
    this.filtered_logo_list = this.logo_list.filter(
      (item) => item.logo_name === this.selected_filter_name
    );
  },

  editItem(item) {
    this.editedIndex = this.logo_list.indexOf(item);
    this.editedItem = Object.assign({}, item);
    this.logoFile = null;
    this.trustLogoFile = null;
    this.dialog = true;
  },

  //  DELETE RECORD (Confirmation)
  deleteItem(item) {
    if (!confirm(`Are you sure you want to delete "${item.logo_name}"?`)) return;

    this.overlay = true;
    axios
      .post("/AdmissionMaster/deleteLoginLogo", { id: item.id })
      .then((res) => {
        if (res.data.code === "SUCCESS") {
          this.showSnackbar("#4caf50", res.data.msg || "Deleted successfully");
          this.getLogoList();
        } else {
          this.showSnackbar("#ff5252", res.data.msg || "Delete failed");
        }
      })
      .catch(() => this.showSnackbar("#ff5252", "Server error while deleting"))
      .finally(() => (this.overlay = false));
  },

  //  REMOVE MAIN LOGO (AWS API + Confirmation)
//   removeMainLogo() {
//     if (!this.editedItem.id) return;

//     if (!confirm("Are you sure you want to remove Main Logo?")) return;

//     this.overlay = true;
//     axios
//       .post("/AdmissionMaster/removeMainLoginLogo", { id: this.editedItem.id })
//       .then((res) => {
//         if (res.data.code === "SUCCESS") {
//           this.showSnackbar("#4caf50", res.data.msg || "Main logo removed");

//           //  remove from UI instantly
//           this.editedItem.logo_path = "";
//           this.logoFile = null;

//           this.getLogoList();
//         } else {
//           this.showSnackbar("#ff5252", res.data.msg || "Failed to remove main logo");
//         }
//       })
//       .catch(() => this.showSnackbar("#ff5252", "Server error while removing main logo"))
//       .finally(() => (this.overlay = false));
//   },

  //  REMOVE TRUST LOGO (AWS API + Confirmation)
  removeTrustLogo() {
    if (!this.editedItem.id) return;

    if (!confirm("Are you sure you want to remove Trust Logo?")) return;

    this.overlay = true;
    axios
      .post("/AdmissionMaster/removeTrustLoginLogo", { id: this.editedItem.id })
      .then((res) => {
        if (res.data.code === "SUCCESS") {
          this.showSnackbar("#4caf50", res.data.msg || "Trust logo removed");

          //  remove from UI instantly
          this.editedItem.trust_logo = "";
          this.trustLogoFile = null;

          this.getLogoList();
        } else {
          this.showSnackbar("#ff5252", res.data.msg || "Failed to remove trust logo");
        }
      })
      .catch(() => this.showSnackbar("#ff5252", "Server error while removing trust logo"))
      .finally(() => (this.overlay = false));
  },

  //  SAVE / UPDATE (Normal Upload)
  save() {
    if (!this.$refs.form.validate()) return;

    const url =
      this.editedIndex === -1
        ? "/AdmissionMaster/saveLoginLogo"
        : "/AdmissionMaster/editLoginLogo";

    let formData = new FormData();

    //  send ID only in edit mode
    if (this.editedIndex !== -1) {
      formData.append("id", this.editedItem.id);
    }

    formData.append("logo_name", this.editedItem.logo_name);

    //  send domain only in add mode
    if (this.editedIndex === -1) {
      formData.append("domainname", this.editedItem.domainname);
    }

    formData.append("login_displayname", this.editedItem.login_displayname || "");

    if (this.logoFile) formData.append("logo_file", this.logoFile);
    if (this.trustLogoFile) formData.append("trust_logo_file", this.trustLogoFile);

    this.overlay = true;

    axios
      .post(url, formData, { headers: { "Content-Type": "multipart/form-data" } })
      .then((res) => {
        if (res.data.code === "SUCCESS") {
          this.showSnackbar("#4caf50", res.data.msg || "Saved successfully");
          this.getLogoList();
          this.close();
        } else {
          this.showSnackbar("#ff5252", res.data.msg || "Operation failed");
        }
      })
      .catch(() => this.showSnackbar("#ff5252", "Server error while saving"))
      .finally(() => (this.overlay = false));
  },

  downloadFile() {
    const excelData = this.filtered_logo_list.map((item, index) => ({
      "S.No": index + 1,
      "Logo Name": item.logo_name,
      Domain: item.domainname,
      "Display Name": item.login_displayname,
    }));

    const worksheet = XLSX.utils.json_to_sheet(excelData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Logos");
    XLSX.writeFile(workbook, "login_logos.xlsx");
  },

  close() {
    this.dialog = false;
    setTimeout(() => {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
      this.logoFile = null;
      this.trustLogoFile = null;
    }, 300);
  },

  showSnackbar(clr, msg) {
    this.snackbar = true;
    this.color = clr;
    this.snackbar_msg = msg;
  },
},
};
</script>

<style scoped>
.edit-avatar {
  transition: 0.3s;
  border: 1px solid #b0bec5;
  cursor: pointer;
}
.edit-avatar:hover {
  background-color: #b0bec5;
}
.edit-v-icon:hover {
  color: white;
}

.delete-avatar {
  transition: 0.3s;
  border: 1px solid #ff5252;
  cursor: pointer;
}
.delete-v-icon {
  color: #ff5252;
  font-size: 18px;
}
.delete-avatar:hover {
  background-color: #ff5252;
}
.delete-avatar:hover .delete-v-icon {
  color: white;
}

.mytable ::v-deep thead th {
  background: linear-gradient(to right, #e49037, #e49037, #e49037) !important;
  color: white !important;
  font-weight: bold !important;
  text-align: center !important;
}

.toolbar {
  background: linear-gradient(to right, #e49037, #e49037, #e49037);
  color: white !important;
}
</style>
